import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { DsLoadingSpinner } from '@frontend/ui/loading-spinner';

@Component({
    selector: 'ms-print-loading-indicator',
    templateUrl: './print-loading-indicator.component.html',
    imports: [RouterModule, DsLoadingSpinner],
})
export class PrintLoadingIndicatorComponent {
    readonly sitecore = inject(Sitecore);
}
